import { useSelector } from "react-redux";
export default function TopDemoPopup() {

  const acctype = useSelector((state) => state.account.accountType)

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <div className="flex-1" />
        <div className="flex-1 flex justify-center">
          <button className={`${acctype=="real"?"bg-green":"bg-red-500"} hover:bg-red-700 text-white font-medium p-1.3 px-5 w-full rounded-sm text-xs text-nowrap`}>
            {
              acctype == "demo" ? "Demo Account" : ""
              
            
            }
          </button>
        </div>
        <div className="flex-1 flex justify-end"></div>
      </div>

    </div>
  );
}
